import { render, staticRenderFns } from "./TheFiltersActions.vue?vue&type=template&id=1813936c&"
import script from "./TheFiltersActions.vue?vue&type=script&lang=js&"
export * from "./TheFiltersActions.vue?vue&type=script&lang=js&"
import style0 from "./TheFiltersActions.vue?vue&type=style&index=0&id=1813936c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports